// extracted by mini-css-extract-plugin
export default {"loaderMedium":"UserDetails_loaderMedium__gwKlS"};